import _ from "lodash";

export function capitalizeFirstLetter(string) {
  return _.capitalize(string);
}

export function makeTitleCase(str) {
  return _.startCase(str);
}
